module.exports = __webpack_public_path__ + "img/12.57f7fada.png";